import { SET_ORIGINAL_STATE, SET_EMAIL_PREFERENCES, SET_IN_PROGRESS } from './actionTypes';

import { environmentApi } from '../../api/environmentApiSlice';
import config from '../../../assets/config';
import internalApi, { THROW_ON_ERROR_V2 } from '../../../assets/internalApi';
import { setLastErrorCode, clearLastErrorCode } from '../../../actions/pageActions';
import { getLocalErrorCode } from '../../../assets/lib';

export const setEmailPreferences = (value) => ({ type: SET_EMAIL_PREFERENCES, payload: value });

export const setOriginalState = (value) => ({ type: SET_ORIGINAL_STATE, payload: value });

export const saveSettings = (value) => async (dispatch) => {
  try {
    dispatch({ type: SET_IN_PROGRESS, payload: true });

    const { settings, userId } = value;

    const requestUri = `${config.apiUrl.dataServer}/api/v1/users/${userId}/settings`;
    // The Email Preferences tab is the only caller. Send just the emailPreferences
    // slice as a partial update (backend supports partial PUTs since SCENARIO-01) so a
    // full-body PUT can't revert freshly auto-saved General settings from a stale baseline.
    await internalApi(
      'put',
      requestUri,
      {
        emailPreferences: settings.emailPreferences,
      },
      THROW_ON_ERROR_V2
    );
    dispatch(environmentApi.util.invalidateTags(['EnvironmentHistory']));

    dispatch(clearLastErrorCode());
    return {};
  } catch (error) {
    dispatch(setLastErrorCode(getLocalErrorCode(error)));
    return { error };
  } finally {
    dispatch({ type: SET_IN_PROGRESS, payload: false });
  }
};
